import { Component } from '@verndale/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import '@splidejs/splide/css';
class ContinuousImageCarousel extends Component {
  currentSlideIndex: number = 0;
  autoplayInterval: NodeJS.Timeout | null = null;
  slides: NodeList | null = null;

  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $slider: this.el.querySelector<HTMLElement>('.splide')
    };
    this.initSlider();
  }

  initSlider() {
    const splide = new Splide(this.dom.$slider as HTMLElement, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 3.5,
      gap: '40px',
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.5
      },
      breakpoints: {
        767: {
          perPage: 2,
          gap: '24px',
          autoScroll: {
            speed: 0.5
          }
        }
      }
    });

    splide.mount({ AutoScroll });
  }
}

export default ContinuousImageCarousel;
